var render, staticRenderFns
import script from "./NumericEnumRelation.vue?vue&type=script&lang=js&"
export * from "./NumericEnumRelation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a077a80",
  null
  
)

export default component.exports